import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Suspense, lazy } from "react";
import "./App.css";
import ProtectedAdminRoute from "./pages/admin/ProtectedAdminRoute";
import NotFound from "./pages/NotFound";
import ProtectedDriverRoute from "./pages/driver/auth/ProtectedDriverRoute";
import DriverDashboard from "./pages/driver/DriverDashboard";
import PaymentCancelled from "./pages/payment_redirects/PaymentCancelled";
import PaymentSuccess from "./pages/payment_redirects/PaymentSuccess";
import PrivacyPolicyPage from "./pages/privacy/PrivacyPolicyPage";
const Home = lazy(() => import("./pages/Home"));
const AdminDashboard = lazy(() => import("./pages/admin/AdminDashboard"));
const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminRegister = lazy(() => import("./pages/admin/AdminRegisterForm"));
const TwoFactorVerify = lazy(() => import("./pages/admin/TwoFactorVerify"));
const EmailInput = lazy(() => import("./pages/driver/auth/EmailInput"));
// const PaymentCancelled = lazy(() =>
//   import("./pages/payment_redirects/PaymentCancelled")
// );
// const PaymentSuccess = lazy(() =>
//   import("./pages/payment_redirects/PaymentSuccess")
// );

const DriverRegister = lazy(() => import("./pages/driver/auth/DriverRegister"));
const DriverForgotPassword = lazy(() => import("./pages/driver/auth/DriverForgotPassword"));
const OTPVerification = lazy(() =>
  import("./pages/driver/auth/OTPVerification")
);

const DriverVerification = lazy(() =>
  import("./pages/admin/DriverVerification")
); // New route

// Loading fallback
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-500"></div>
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen">
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            {/* Public routes */}
            <Route path="/" element={<Home />} />
            <Route path="/payment-cancelled" element={<PaymentCancelled />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

            {/* Admin routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/verify-2fa" element={<TwoFactorVerify />} />
            <Route path="/admin/auth/register" element={<AdminRegister />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedAdminRoute>
                  <AdminDashboard />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/driver-verification/:driverId"
              element={
                <ProtectedAdminRoute>
                  <DriverVerification />
                </ProtectedAdminRoute>
              }
            />
            <Route
              path="/admin/"
              element={<Navigate to="/admin/login" replace />}
            />

            {/* Driver routes */}
            <Route path="/driver/login" element={<EmailInput />} />
            <Route path="/driver/register" element={<DriverRegister />} />
            <Route path="/driver/forgot-password" element={<DriverForgotPassword />} />
            <Route
              path="/driver/verify-otp/:email"
              element={<OTPVerification />}
            />
            <Route
              path="/driver/dashboard"
              element={
                <ProtectedDriverRoute>
                  <DriverDashboard />
                </ProtectedDriverRoute>
              }
            />

            {/* 404 route - must be last */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
    </BrowserRouter>
  );
}

export default App;
